export const serviciosIniciales = {
  especialidad: [
    { id: 1, nombre: "Cardiología", duracionTurnoEnMins: 30, costo: 5000 },
  ],
  practica: [
    { id: 2, nombre: "Electrocardiograma", duracionTurnoEnMins: 20, costo: 3500 },
  ],
};